import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteExpenses', {
    sectionName: 'Expenses',
    categoryColumnName: 'Category',
    categoryFieldPlaceholder: 'Select category',
    accountColumnName: 'Account',
    accountFieldPlaceholder: 'Select account',
    amountColumnName: 'Amount',
    amountFieldPlaceholder: 'Enter amount',
    taxCodeColumnName: 'Tax code',
    taxCodeFieldPlaceholder: 'Select tax code',
    taxRateColumnName: 'Tax rate',
    taxAmountColumnName: 'Tax amount',
    grossAmountColumnName: 'Gross amount',
    grossAmountFieldPlaceholder: 'Enter gross amount',
    memoColumnName: 'Memo',
    memoFieldPlaceholder: 'Enter memo',
    departmentColumnName: 'Department',
    departmentFieldPlaceholder: 'Select department',
    classColumnName: 'Class',
    classFieldPlaceholder: 'Select class',
    locationColumnName: 'Location',
    locationFieldPlaceholder: 'Select location',
    customerColumnName: 'Customer:Project',
    projectTaskColumnName: 'Project Task',
    customerFieldPlaceholder: 'Select value',
    projectTaskFieldPlaceholder: 'Select value',
    billableColumnName: 'Billable',
    inputPlaceholder: 'Enter value',
    datePlaceholder: 'Select date',
    amortizationSchedule: 'Amortization Schedule',
    amortizationStartDate: 'Amortization Start Date',
    amortizationEndDate: 'Amortization End Date',
    amortizationResidual: 'Amortization Residual',
    differentAmountWarningDescription: 'Bill line amount differs from File line amount.',
    differentAmountWarningLabel1: 'Bill line amount:',
    differentAmountWarningLabel2: 'File line amount:',
    differentTaxAmountWarningDescription: 'Bill line tax amount differs from File line tax amount.',
    differentTaxAmountWarningLabel1: 'Bill line tax amount:',
    differentTaxAmountWarningLabel2: 'File line tax amount: ',
    multipleAccountsWarning:
        '{contactDisplayName} {requestName} had multiple accounts in the past. Check suggested accounts.',
    multipleCategoriesWarning:
        '{contactDisplayName} {requestName} had multiple categories in the past. Check suggested categories.',
    multipleTaxCodesWarning:
        '{contactDisplayName} {requestName} had multiple tax rates in the past. Check suggested tax rate.',
    multipleCustomersWarning:
        '{contactDisplayName} {requestName} had multiple customers in the past. Check suggested customers.',
    groupEdit: 'Edit selected',
    groupClone: 'Clone selected',
    groupRemove: 'Remove selected',
});
